"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.object.to-string.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _product = require("@/api/product");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/components/Pagination/index.vue"));
var _enum = require("@/utils/enum");
var OrderProductHistory = /*#__PURE__*/function (_Vue) {
  function OrderProductHistory() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderProductHistory);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderProductHistory, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "tagOptions", _enum.tagOptions);
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      isPublished: null,
      limit: 10
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", void 0);
    return _this;
  }
  (0, _inherits2.default)(OrderProductHistory, _Vue);
  return (0, _createClass2.default)(OrderProductHistory, [{
    key: "watchProductId",
    value: function watchProductId() {
      this.fetchData();
    }
  }, {
    key: "getSummaries",
    value: function getSummaries(_ref) {
      var data = _ref.data;
      var sum = [];
      sum[1] = data.reduce(function (prev, cur) {
        return prev + cur.quantity;
      }, 0);
      sum[2] = data.reduce(function (prev, cur) {
        return prev + cur.finalPrice;
      }, 0);
      sum[1] = this.$formatNumberVN(sum[1]);
      sum[2] = this.$formatNumberVN(sum[2]);
      return sum;
    }
  }, {
    key: "fetchData",
    value: function fetchData() {
      var _this2 = this;
      _product.productApi.orderHistory(this.productId, this.query).then(function (res) {
        _this2.data = res.data.orderDetails;
        _this2.total = res.data.total;
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OrderProductHistory.prototype, "productId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("productId", {
  deep: true,
  immediate: true
})], OrderProductHistory.prototype, "watchProductId", null);
OrderProductHistory = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    Pagination: _index.default
  }
})], OrderProductHistory);
var _default = exports.default = OrderProductHistory;